// extracted by mini-css-extract-plugin
export default {"root":"FormToggle_root__RAUGs","input":"FormToggle_input__dXIkz","dotWrap":"FormToggle_dotWrap__CPVFL","dot":"FormToggle_dot__VjWIC","label":"FormToggle_label__bS+fH"};